(() => {
  const SELECTORS = {
    product: '.js-product',
    title: '.product-title',
    productMedia: '#product-media',
    defaultGallery: '#product-media media-gallery',
    detailsSection: '.cc-product-details',
    data: '[data-beties-variant-content]'
  };

  function getProductRoot() {
    const data = document.querySelector(SELECTORS.data);
    return data ? data.closest('section, .shopify-section')?.querySelector(SELECTORS.product) || document.querySelector(SELECTORS.product) : null;
  }

  function getRecord(variantId) {
    if (!variantId) return null;
    const data = document.querySelector(SELECTORS.data);
    return data ? data.querySelector(`.beties-variant-record[data-variant-id="${variantId}"]`) : null;
  }

  function saveDefaults(productRoot) {
    if (!productRoot || productRoot.dataset.betiesDefaultsSaved === 'true') return;

    const title = productRoot.querySelector(SELECTORS.title);
    if (title) title.dataset.betiesDefaultHtml = title.innerHTML;

    const details = document.querySelector(SELECTORS.detailsSection);
    if (details) {
      details.querySelectorAll('.disclosure').forEach((disclosure, index) => {
        const heading = disclosure.querySelector('.disclosure__title');
        const content = disclosure.querySelector('.disclosure__content');
        disclosure.dataset.betiesIndex = String(index);
        if (heading) heading.dataset.betiesDefaultHtml = heading.innerHTML;
        if (content) content.dataset.betiesDefaultHtml = content.innerHTML;
      });
    }

    productRoot.dataset.betiesDefaultsSaved = 'true';
  }

  function restoreDefaults(productRoot) {
    const title = productRoot?.querySelector(SELECTORS.title);
    if (title?.dataset.betiesDefaultHtml !== undefined) {
      title.innerHTML = title.dataset.betiesDefaultHtml;
    }

    const details = document.querySelector(SELECTORS.detailsSection);
    if (details) {
      details.querySelectorAll('.disclosure').forEach((disclosure) => {
        const heading = disclosure.querySelector('.disclosure__title');
        const content = disclosure.querySelector('.disclosure__content');
        if (heading?.dataset.betiesDefaultHtml !== undefined) heading.innerHTML = heading.dataset.betiesDefaultHtml;
        if (content?.dataset.betiesDefaultHtml !== undefined) content.innerHTML = content.dataset.betiesDefaultHtml;
        content?.classList.remove('beties-variant-detail', 'beties-variant-description');
      });
    }

    document.querySelector('.beties-variant-gallery')?.remove();
    const productMedia = document.querySelector(SELECTORS.productMedia);
    if (productMedia) productMedia.classList.remove('beties-variant-gallery-active');

    const defaultGallery = document.querySelector(SELECTORS.defaultGallery);
    if (defaultGallery) {
      defaultGallery.classList.remove('beties-default-gallery--hidden');
      defaultGallery.hidden = false;
      defaultGallery.removeAttribute('aria-hidden');
    }
  }

  function normalizeDetailBreaks(content, productDetails = false) {
    const richText = content.querySelector('.metafield-rich_text_field');
    if (!richText) return;
    // Handle raw line breaks in Shopify Rich Text explicitly. Keep existing <br>
    // elements, without duplicating their trailing HTML whitespace.
    const walker = document.createTreeWalker(richText, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (!node.data.includes('\n') && !node.data.includes('\r')) return;
      let value = node.data.replace(/\r\n?/g, '\n');
      if (node.previousSibling?.nodeName === 'BR') value = value.replace(/^\n/, '');
      if (node.nextSibling?.nodeName === 'BR') value = value.replace(/\n$/, '');
      const fragment = document.createDocumentFragment();
      value.split('\n').forEach((part, index) => {
        if (index) fragment.appendChild(document.createElement('br'));
        if (part) fragment.appendChild(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
    if (!productDetails) return;
    // The original product's compact specifications use these bold labels.
    // Restore their row boundaries even if a previous transfer lost the breaks.
    const labels = new Set(['größe:', 'füllstärke:', 'füllgewicht:', 'füllung:',
      'bezug:', 'form:', 'einsatzbereich:', 'herkunft:']);
    richText.querySelectorAll('strong, b').forEach((label) => {
      if (!labels.has(label.textContent.trim().toLowerCase()) || label.closest('li')) return;
      let previous = label.previousSibling;
      while (previous && previous.nodeType === Node.TEXT_NODE && !previous.textContent.trim()) {
        previous = previous.previousSibling;
      }
      if (previous && previous.nodeName !== 'BR') {
        label.before(document.createElement('br'));
      }
    });
  }

  function setDetailPanel(disclosure, titleText, html, productDetails = false) {
    if (!disclosure || !html) return;
    const heading = disclosure.querySelector('.disclosure__title');
    const content = disclosure.querySelector('.disclosure__content');
    if (heading && titleText) heading.textContent = titleText;
    if (content) {
      content.innerHTML = html;
      normalizeDetailBreaks(content, productDetails);
      content.classList.add('beties-variant-detail');
      if (titleText === 'Produktbeschreibung') content.classList.add('beties-variant-description');
    }
  }

  function applyDetailContent(record) {
    const details = document.querySelector(SELECTORS.detailsSection);
    if (!details || !record) return;

    const disclosures = [...details.querySelectorAll('.disclosure')];
    if (!disclosures.length) return;

    const info = record.querySelector('template[data-beties-tab="informationen"]')?.innerHTML.trim();
    const productDetails = record.querySelector('template[data-beties-tab="produktdetails"]')?.innerHTML.trim();
    const care = record.querySelector('template[data-beties-tab="pflegehinweise"]')?.innerHTML.trim();

    // Das Enterprise-Theme rendert diese drei Produktbereiche in dieser Reihenfolge:
    // 0 = Informationen, 1 = Produktdetails im Überblick, 2 = Pflegehinweise.
    setDetailPanel(disclosures[0], 'Produktbeschreibung', info);
    setDetailPanel(disclosures[1], 'Produktdetails', productDetails, true);
    setDetailPanel(disclosures[2], 'Pflegehinweise', care);
  }

  function buildGallery(record) {
    const productMedia = document.querySelector(SELECTORS.productMedia);
    const defaultGallery = document.querySelector(SELECTORS.defaultGallery);
    if (!productMedia || !record) return;

    const imageData = [...record.querySelectorAll('[data-beties-image]')].map((el) => ({
      src: el.dataset.betiesImage,
      alt: el.dataset.alt || ''
    }));
    if (!imageData.length) return;

    document.querySelector('.beties-variant-gallery')?.remove();
    productMedia.classList.add('beties-variant-gallery-active');
    if (defaultGallery) {
      defaultGallery.classList.add('beties-default-gallery--hidden');
      defaultGallery.hidden = true;
      defaultGallery.setAttribute('aria-hidden', 'true');
    }

    let activeIndex = 0;
    const gallery = document.createElement('div');
    gallery.className = 'beties-variant-gallery';
    gallery.innerHTML = `
      <div class="beties-variant-gallery__stage">
        <img class="beties-variant-gallery__main" src="${imageData[0].src}" alt="${escapeHtml(imageData[0].alt)}" loading="eager">
        <button type="button" class="beties-variant-gallery__nav beties-variant-gallery__nav--prev" aria-label="Vorheriges Bild">‹</button>
        <button type="button" class="beties-variant-gallery__nav beties-variant-gallery__nav--next" aria-label="Nächstes Bild">›</button>
        <div class="beties-variant-gallery__counter"><span>1</span> / ${imageData.length}</div>
      </div>
      <div class="beties-variant-gallery__thumbs" role="list"></div>
    `;

    const mainImage = gallery.querySelector('.beties-variant-gallery__main');
    const current = gallery.querySelector('.beties-variant-gallery__counter span');
    const thumbs = gallery.querySelector('.beties-variant-gallery__thumbs');

    const show = (index) => {
      activeIndex = (index + imageData.length) % imageData.length;
      mainImage.src = imageData[activeIndex].src;
      mainImage.alt = imageData[activeIndex].alt;
      current.textContent = String(activeIndex + 1);
      thumbs.querySelectorAll('.beties-variant-gallery__thumb').forEach((btn, i) => {
        btn.classList.toggle('is-active', i === activeIndex);
        btn.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
      });
    };

    imageData.forEach((image, index) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `beties-variant-gallery__thumb${index === 0 ? ' is-active' : ''}`;
      btn.setAttribute('aria-label', `Bild ${index + 1} anzeigen`);
      btn.innerHTML = `<img src="${image.src}" alt="" loading="lazy">`;
      btn.addEventListener('click', () => show(index));
      thumbs.appendChild(btn);
    });

    gallery.querySelector('.beties-variant-gallery__nav--prev').addEventListener('click', () => show(activeIndex - 1));
    gallery.querySelector('.beties-variant-gallery__nav--next').addEventListener('click', () => show(activeIndex + 1));

    productMedia.prepend(gallery);
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function applyVariant(variantId) {
    const productRoot = getProductRoot();
    if (!productRoot) return;

    saveDefaults(productRoot);
    restoreDefaults(productRoot);

    const record = getRecord(String(variantId || ''));
    if (!record) return;

    const title = productRoot.querySelector(SELECTORS.title);
    if (title && record.dataset.title) title.textContent = record.dataset.title;

    applyDetailContent(record);
    buildGallery(record);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const data = document.querySelector(SELECTORS.data);
    if (!data) return;
    const urlVariant = new URL(window.location.href).searchParams.get('variant');
    const initialVariant = urlVariant || data.dataset.defaultVariantId;
    if (initialVariant) applyVariant(initialVariant);
  }, { once: true });

  document.addEventListener('on:variant:change', (event) => {
    const variantId = event.detail?.variant?.id;
    if (variantId) applyVariant(variantId);
  });
})();
